import React from "react";

interface VariableComponentProps {
    title: string;
    onDelete: () => void;
}

export const VariableComponent = ({ title, onDelete }: VariableComponentProps) => {
    return (
        <>
            &#xFEFF;
            <span className="space-x-1 border border-gray px-1" contentEditable={false}>
                <span>{title}</span>
                {/* Quill's styles more priority than tailwind */}
                <a
                    target="_blank"
                    className="cursor-pointer"
                    style={{ textDecoration: "none", color: "#FF5A5A" }}
                    onClick={onDelete}
                >
                    x
                </a>
            </span>
            &#xFEFF;
        </>
    );
};
